"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsCompanySSN = exports.validateSSN = exports.sanitiseSSN = exports.prettifySSN = void 0;
var Regex_1 = require("./Regex");
var StringUtils_1 = require("./StringUtils");
var prettifySSN = function (ssn) {
    var ssnSanitised = (0, StringUtils_1.stripCharacter)(ssn);
    if (ssnSanitised.length <= 6)
        return ssnSanitised;
    return "".concat(ssnSanitised.substr(0, 6), "-").concat(ssnSanitised.substr(6));
};
exports.prettifySSN = prettifySSN;
var sanitiseSSN = function (ssn) {
    return ssn.replace(Regex_1.RegexConstants.NotSSN, '');
};
exports.sanitiseSSN = sanitiseSSN;
var validateSSN = function (ssn) {
    if (ssn.length !== 10)
        return false;
    if (!Regex_1.RegexConstants.Number.test(ssn))
        return false;
    var _a = Array.from(ssn).map(function (char) { return parseInt(char, 10); }), d1 = _a[0], d2 = _a[1], m1 = _a[2], m2 = _a[3], y1 = _a[4], y2 = _a[5], r1 = _a[6], r2 = _a[7], p = _a[8], c = _a[9];
    if (c !== 9 && c !== 0)
        return false;
    var p0 = (3 * d1 + 2 * d2 + 7 * m1 + 6 * m2 + 5 * y1 + 4 * y2 + 3 * r1 + 2 * r2) % 11;
    if (p0 === 0) {
        if (p !== 0)
            return false;
    }
    else if (p !== 11 - p0)
        return false;
    return true;
};
exports.validateSSN = validateSSN;
var getIsCompanySSN = function (ssn) {
    if (ssn.length !== 10)
        return false;
    var firstDigit = Number(ssn.charAt(0));
    return firstDigit >= 4;
};
exports.getIsCompanySSN = getIsCompanySSN;
//# sourceMappingURL=Ssn.js.map